<template>
<div class="parent_block_wrap   border-round-md" @click="select" :class="selected">

<div class="block_header"  >
<div class="block_handle"><i class="pi pi-align-justify  pt-2 "></i></div>
<div class="block_name"> {{block.name}}</div>
</div>
<hr>

<div class="block_content border-round-md">
<template v-if="block.elements.length">
	
<draggable 
v-model="block.elements"
data_container_id="display_grid"
group="grid" 
@start="start" 
@end="end" 
@change="change"
handle=".block_handle"
v-bind="dragOptions"
item-key="id">
<template #item="{element}">
<SchemaEditorDisplayChildBlock 
:element="element" 
/>

</template>
</draggable>


</template>
<template v-else>
	<div class="empty_block">
	<i class="pi pi-plus text-primary text-2xl"></i>
	<p class="text-primary my-1">Eklemek için tıklayın</p>
		
	</div>
</template>

</div>

</div>
</template>

<script>
import SchemaEditorDisplayChildBlock from "./SchemaEditorDisplayChildBlock"
export default {

  name: 'SchemaEditorDisplayParentBlock',
  props:["block"],
  data () {
    return {
    	drag:false,
    }
  },
  components:{SchemaEditorDisplayChildBlock},
  computed:{
  	selected()
  	{
  		if(this.$store.state.customresultdisplays.selected_element)
  		{
  			if(this.$store.state.customresultdisplays.selected_element.id == this.block.id)
  			{
  				return "selected"
  			}
  		}
  		return ""
  	},  	
  	dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
  },
  methods:{
  	select()
  	{
  		this.$store.dispatch('customresultdisplays/setSelectedElement',this.block) 
  	},
  	end(event)
    {
      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },
    change(event)
    {
      this.$emit("orderChanged",this.schema)
    },
  }
}
</script>

<style lang="css" scoped>
.parent_block_wrap{
	width: 100%;
	min-height: 100px;
	margin-bottom: 6px;
	padding: 4px;
	box-shadow: rgb(93 62 188 / 10%) 0px 6px 24px;
	border-style: solid;
	border-width: medium;
	border-color: transparent;
}
.block_header{
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding: 0 2px;
	cursor: pointer;
}
.block_handle{
	width: 20px;
}
.block_content{
	display: block;
	min-height: 100px;
	padding: 4px;
	border: 1px solid #352f8d;
}
.selected{
	border-color: #352f8d;
}
.empty_block{
	width: 100%;
	display: flex;
	min-height: 100px;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	cursor: pointer;
}
.empty_block:hover{
	opacity: 0.8;
}
</style>